import { useMutation } from '@tanstack/react-query';
import publicAxiosInstance from '../../../../constants/publicAxiosInstance';
import { toast } from 'react-toastify';

interface GenerateInvitedUserOtpResponse {
  status?: boolean;
  message?: string;
  data?: {
    verificationId?: string;
    [key: string]: any;
  };
}

interface GenerateInvitedUserOtpParams {
  userId: string;
  verificationType: string;
  phoneNumber: string;
  emailAddress: string;
}

const generateInvitedUserOtp = async (params: GenerateInvitedUserOtpParams): Promise<GenerateInvitedUserOtpResponse> => {
  const { data } = await publicAxiosInstance().post<GenerateInvitedUserOtpResponse>(
    '/newUsers/sendOTPForInvitedUserVerification',
    params
  );
  return data;
};

export const useGenerateInvitedUserOtp = () => {
  return useMutation({
    mutationFn: generateInvitedUserOtp,
    onSuccess: (data) => {
      if (data.status) {
        toast.success(data.message || 'OTP sent successfully');
      }
    },
    onError: (error: any) => {
      toast.error(error?.message || 'Failed to generate OTP. Please try again.');
    },
  });
};
